import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NetworkConnectivityService } from '../services/network-connectivity.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private readonly networkConnectivityService: NetworkConnectivityService) { }

    private normalizeError(error: HttpErrorResponse): unknown {
        const payload = error?.error;

        if (payload instanceof ProgressEvent) {
            return {
                status: error.status,
                statusText: error.statusText,
                url: error.url,
                target: payload.target,
            };
        }

        if (payload && typeof payload === 'object') {
            return {
                status: error.status,
                statusText: error.statusText,
                url: error.url,
                ...(payload as object),
            };
        }

        if (typeof payload === 'string' && payload.length > 0) {
            try {
                return { 
                    ...JSON.parse(payload), 
                    status: error.status, 
                    statusText: error.statusText, 
                    url: error.url 
                };
            } catch {
                return { 
                    message: payload, 
                    status: error.status, 
                    statusText: error.statusText, 
                    url: error.url 
                };
            }
        }

        if (error?.statusText) {
            return {
                status: error.status,
                statusText: error.statusText,
                url: error.url,
                message: error.statusText,
            };
        }

        return error;
    }

    intercept(request: HttpRequest<LegacyAny>, next: HttpHandler): Observable<HttpEvent<LegacyAny>> {
        return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
            // Skip network error check for localhost calls (local device reading)
            const isLocalhostCall = request.url && request.url.toLowerCase().includes('localhost');
            
            // Check if this is a network-related error (but not for localhost calls)
            if (!isLocalhostCall && this.networkConnectivityService.isNetworkError(err)) {
                // Show network error popup
                this.networkConnectivityService.showNoInternetPopup();
            }
            
            return throwError(() => this.normalizeError(err));
        }))
    }
}

